// extracted by mini-css-extract-plugin
module.exports =  {"root":"xBA1tEW0yeEBRmVIFZY8","title":"MN38RgmFkUyH5lo6FGww","description":"qvRvNwGWhB10FAy0WOSa"};